export default __webpack_public_path__ + "bayes-bg.png";